import { useCallback, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./SignUp.css";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { validateReferralLink } from "./SignUp";
import { baseUrl, GetToken } from "../../App";

type IUserDetails = {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  sourceOfDiscovery: string;
  newLetter: string;
  uids: string;
  Country: string;
  showEmail: boolean;
  inviteCode: string;
};

const CompleteSocialLogins = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [newsLetter, setNewsLetter] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notification, setNotification] = useState("");
  const [showEmail, setShowEmail] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails: IUserDetails = location.state;
  const handleCloseNotification = () => {
    setShowNotification(false);
    navigate("/signin");
  };

  useEffect(() => {
    setShowEmail(userDetails.showEmail);
    setUserEmail(userDetails.email);
  }, [userDetails.showEmail, userDetails.email]);

  const sendEmail = useCallback(async () => {
    const emailBody = {
      sender: {
        name: "Doyenify Academy",
        email: "info@doyenify.com",
      },
      to: [
        {
          email: userEmail,
        },
      ],
      replyTo: {
        email: "info.doyenify@gmail.com",
      },
      subject: "You have successfully registered to Doyenify Academy",
      htmlContent: `<html><head>
  
              <style>
                  body {
                      background-color:#696969;
                  }
                  .imgtag{
                      justify-content: center;
                      align-items: center;
                      margin-left: 45%;
                  }
                  .welcome {
                      text-align: center;
                      color: #696969;
                  }
          
                  .content {
                      background-color: #ffffff;
                      margin: 15px;
                      padding: 20px;
                  }
              </style>
          </head>
          
          <body>
              <div class="imgtag">
                  <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
              </div>
                  
              <div class="content">
                  <h2 class="welcome">{{params.username}}, Welcome to Doyenify Academy</h2>
                  
                  <p>Dear {{params.username}},</p>
                  <p>Welcome to <a href="https://academy.doyenify.com" >Doyenify Academy</a>.! We are excited to have you as a part of our community. Get ready for a fantastic journey filled with Hands-On Practical Experience</p>
                  <p>Here's a quick overview of what you can expect:
                  <ol type="1">
                      <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Expert-Led Learning:</span> <p>Our courses are led by experienced industry professionals who bring their real-world insights and expertise into the classroom, giving you practical knowledge that is immediately applicable. </p>
                      </li>
                      <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Hands-On Projects:</span> <p>We emphasize learning by doing. Throughout the courses, you will work on a series of hands-on projects, building a robust portfolio that showcases your skills to potential employers.</p>
                      </li>
                      <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Job-Ready Skills:</span> <p>Our curriculum is carefully crafted to match the skills demanded by the job market. By the time you graduate, you will possess the coding and problem-solving abilities that employers are looking for.</p>
                      </li>
                      <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Problem-Solving Focus:</span> <p> Coding is about more than just syntax; it is about finding innovative solutions. Our bootcamp hones your ability to approach complex problems creatively and analytically.</p>
                      </li>
                      <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Results-Driven Approach:</span> <p>Our success is measured by your success. We are dedicated to helping you achieve your career goals and providing you with the skills to excel in the tech industry.</p>
                      </li>
                  </ol>
                  
                  <p>We are thrilled to embark on this journey with you. If you have any questions, feedback, or suggestions, do not hesitate to reach out to us at info@doyenify.com or +372 5670 4920. Remember, your experience and satisfaction are our top priorities.</p>
                  <p>Thank you for choosing <a href="https://academy.doyenify.com" >Doyenify Academy</a>. Let's help you achieve your Tech dreams!</p>
                  <p>Best regards,</p>
                  <p>DoyenifyAcademy</p>
          
              </div>
          
              
          </body>
          </html>
                              
                          `,
      params: {
        username: userDetails.firstname,
      },
    };
    try {
      const responseToken = await fetch(
        "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
          process.env.REACT_APP_SERVICE_KEY,
        {
          method: "post",
          body: JSON.stringify({
            email: process.env.REACT_APP_SERVICE_EMAIL,
            password: process.env.REACT_APP_SERVICE_PASSWORD,
            returnSecureToken: true,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const userToken = await responseToken.json();
      await axios
        .post(String(process.env.REACT_APP_SERVICE_APP_URL), emailBody, {
          headers: { Authorization: `Bearer ${userToken.idToken}` },
        })
        .then()
        .catch(() => {
          console.log("(axios) an error occurred");
        });
    } catch (error: any) {
      console.log("Error sending email to new user");
      console.log(error);
    }
  }, [userEmail, userDetails.firstname]);

  const createUserProfile = useCallback(async () => {
    let referred = false;
    let idToken = await GetToken();
    const inviteCode = userDetails.inviteCode;
    if (inviteCode) {
      referred = await validateReferralLink(
        inviteCode,
        userDetails.firstname.trim() + " " + userDetails.lastname.trim(),
        userEmail.trim(),
      );
    }

    const userBody = {
      firstname: userDetails.firstname.trim(),
      lastname: userDetails.lastname.trim(),
      email: userEmail.trim(),
      phone: phoneNumber.trim(),
      sourceOfDiscovery: "Website",
      newLetter: String(newsLetter),
      uids: userDetails.uids.trim(),
      Country: userDetails.Country.trim(),
      Referred: referred,
    };
    if (trigger === 0) {
      try {
        await axios
          .get(`${baseUrl}/registration`, {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })
          .then((response) => {
            var allUsers = response.data;
            var EmailArray = [];
            for (const [key, value] of Object.entries(allUsers)) {
              var value1: any;
              value1 = key;
              value1 = value;
              EmailArray.push(value1["email"]);
            }
            if (EmailArray.includes(userEmail)) {
              setShowNotification(true);
              setNotification(
                "Account already exists: Please sign in or use Forgot Password",
              );
              // if (auth.currentUser) { auth.currentUser.delete(); }
            } else {
              try {
                axios.post(`${baseUrl}/registration`, userBody, {
                  headers: {
                    Authorization: `Bearer ${idToken}`,
                  },
                });
                sendEmail();
                const from = location.state?.from || "/";
                navigate(from);
              } catch (error: any) {
                console.log(
                  "Could not save user details into db: " + error.message,
                );
              }
            }
          });
      } catch (error: any) {
        console.log("Could not verify user details in db: " + error.message);
      }
      setTrigger(1);
    }
  }, [
    trigger,
    userEmail,
    phoneNumber,
    navigate,
    newsLetter,
    sendEmail,
    userDetails.Country,
    userDetails.firstname,
    userDetails.lastname,
    userDetails.uids,
    location.state?.from,
    userDetails.inviteCode,
  ]);

  return (
    <div>
      <Modal show={showNotification} centered={true}>
        <Modal.Body style={{ marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {notification}
            <div style={{ marginTop: "1rem" }}>
              <button
                onClick={handleCloseNotification}
                style={{
                  backgroundColor: "#047E35",
                  color: "white",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.25rem",
                  cursor: "pointer",
                  border: "none",
                  marginRight: "1rem",
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <div className="row">
        <div className="col-md-4">
          <div className="row myfirstcon">
            <h4 style={{ fontWeight: "600" }}>Unlock Your Potential:</h4>
            <h4 style={{ fontWeight: "600" }}>Sign Up Today!</h4>
            <p>Take the First Step Towards Your Bright Future</p>
            <img
              src="../../images/enrolloneimg.png"
              alt="enrolimg"
              style={{ width: "100%", height: "241px" }}
            />
          </div>
        </div>
        <div className="col-md-8 p-0">
          <div>
            <h2>Please fill in the below to complete the Registration</h2>
          </div>

          <div className="textinputsp">
            <PhoneInput
              country={"ng"}
              value={phoneNumber}
              onChange={(phoneNumber) => setPhoneNumber(phoneNumber)}
              isValid={(value, country: any) => {
                if (value.match(/^([0|[0-9]{1,5})?([7-9][0-9]{8})$/)) {
                  return "Invalid value: " + value + ", " + country.name;
                } else if (value.match(/^([0|[0-9]{1,5})?([7-9][0-9]{8})$/)) {
                  return false;
                } else {
                  return true;
                }
              }}
            />
          </div>
          <div className={showEmail ? "EmailInput" : "NoEmailInput"}>
            <div className="socialemail">
              <label htmlFor="email">Enter your Email</label>
              <input
                type="email"
                value={userEmail}
                placeholder="johndoe@email.com"
                onChange={(e) => {
                  setUserEmail(e.target.value);
                }}
              />
            </div>
          </div>
          <div
            style={{
              marginBottom: "10px",
              marginTop: "10px",
            }}
          >
            <input
              type="checkbox"
              checked={newsLetter}
              onChange={(e) => {}}
              onClick={() => {
                setNewsLetter(!newsLetter);
              }}
            />{" "}
            <span>Tick to subscribe to our NewsLetter</span>
          </div>
          <button
            className="btn btn-success"
            style={{ marginBottom: "20px" }}
            onClick={createUserProfile}
          >
            Click to Complete
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompleteSocialLogins;
